import Table from './components/Table'
import TableActions from './components/TableActions'
import EkgTable from './EkgTable'
import BloodPressureTable from './BloodPressureTable'
import ReportTable from './ReportTable'
import PatientDirectoryTable from './PatientDirectoryTable'
import EnrollmentTable from './EnrollmentTable'
import TeamInvitesTable from './TeamInvitesTable'
import TeamMembersTable from './TeamMembersTable'
import WeightTable from './WeightTable'

export {
  Table as default,
  TableActions,
  EkgTable,
  BloodPressureTable,
  ReportTable,
  PatientDirectoryTable,
  EnrollmentTable,
  TeamInvitesTable,
  TeamMembersTable,
  WeightTable,
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/index.js